/* MTR Configuratore v5 — colore, drop gate, retro ristrutturato, spedizione */
(function () {
  'use strict';

  /* ============================================================
     COSTANTI PREZZI
     ============================================================ */
  var BASE_PRICE = 25.00;      // T-shirt base (include logo cuore fronte + logo/scritta retro alto)
  var ADDON_NAME = 5.00;        // +5€ per ogni "nome" aggiunto
  var ADDON_LOGO_BASSO = 10.00; // +10€ logo basso retro
  var ADDON_NOME_BASSO = 5.00;  // +5€ nome con logo basso (totale 15€ per logo+nome basso)

  /* ============================================================
     STATO
     ============================================================ */
  var state = {
    colore: 'nero',            // 'nero' | 'grigio'
    fronte: 'logo',            // 'logo' | 'logo_nome'
    maniche: 'nessuna',        // 'nessuna' | 'nome_dx' | 'nome_sx' | 'nome_entrambe'
    retro_top: 'font1',        // 'logo' | 'font1' | 'font2' (obbligatorio, incluso)
    retro_bottom: 'nessuno',   // 'nessuno' | 'logo' | 'logo_nome' (opzionale)
    taglia: 'L',
    testo_nome: '',
    currentStep: 1,
    totalAddons: 0,
    totalPrice: BASE_PRICE,
    shippingCost: 5.90,
    shippingFreeThreshold: 50
  };

  /* ============================================================
     IMMAGINI (con fallback colore grigio via prefisso G-)
     ============================================================ */
  var IMAGES = (window.MTR_PRODUCT && window.MTR_PRODUCT.images) ? window.MTR_PRODUCT.images : {};

  function img(key) {
    if (!key) return '';
    if (state.colore === 'grigio') {
      var grey = key.replace(/^mtr-/, 'mtr-G-');
      if (IMAGES[grey]) return IMAGES[grey];
    }
    return IMAGES[key] || '';
  }

  var FRONTE_MAP = {
    logo:      'mtr-FRONTE-LOGO',
    logo_nome: 'mtr-FRONTE-LOGO-NOME'
  };

  var DX_MAP = {
    nessuna:       'mtr-CLEAN-DX',
    nome_dx:       'mtr-LATERALE-DX-NOME',
    nome_sx:       'mtr-CLEAN-DX',
    nome_entrambe: 'mtr-LATERALE-DX-NOME'
  };

  var SX_MAP = {
    nessuna:       'mtr-CLEAN-SX',
    nome_dx:       'mtr-CLEAN-SX',
    nome_sx:       'mtr-LATERALE-SX-NOME',
    nome_entrambe: 'mtr-LATERALE-SX-NOME'
  };

  // Mappa retro_top|retro_bottom -> image key
  var RETRO_MAP = {
    'logo|nessuno':    'mtr-RETRO-NS-LOGO-ALTO',
    'logo|logo':       'mtr-RETRO-NS-LOGO-ALTO-LOGO-BASSO',
    'logo|logo_nome':  'mtr-RETRO-NS-LOGO-ALTO-NOME-BASSO',
    'font1|nessuno':   'mtr-RETRO-F1-PAYOFF',
    'font1|logo':      'mtr-RETRO-F1-PAYOFF-LOGO',
    'font1|logo_nome': 'mtr-RETRO-F1-PAYOFF-LOGO-NOME',
    'font2|nessuno':   'mtr-RETRO-F2-PAYOFF',
    'font2|logo':      'mtr-RETRO-F2-PAYOFF-LOGO',
    'font2|logo_nome': 'mtr-RETRO-F2-PAYOFF-LOGO-NOME'
  };

  // Fallback quando la chiave esatta non esiste
  var RETRO_FALLBACK = {
    'logo|logo':      'mtr-RETRO-NS-LOGO-ALTO',
    'logo|logo_nome': 'mtr-RETRO-NS-LOGO-ALTO'
  };

  function getRetroImgKey() {
    var key = state.retro_top + '|' + state.retro_bottom;
    var primary = RETRO_MAP[key];
    if (primary && img(primary)) return primary;
    if (RETRO_FALLBACK[key]) return RETRO_FALLBACK[key];
    return 'mtr-RETRO-NS-LOGO-ALTO';
  }

  /* ============================================================
     CALCOLO PREZZO
     "addons" = numero di CHUNK da €5 oltre la base (= variante _p Shopify)
     ============================================================ */
  function calculatePrice() {
    var chunks = 0; // ogni chunk = €5

    // Fronte: +nome = 1 chunk
    if (state.fronte === 'logo_nome') chunks += 1;

    // Maniche: 1 o 2 nomi
    if (state.maniche === 'nome_dx' || state.maniche === 'nome_sx') chunks += 1;
    else if (state.maniche === 'nome_entrambe') chunks += 2;

    // Retro basso: logo = 2 chunk (€10), logo+nome = 3 chunk (€15)
    if (state.retro_bottom === 'logo') chunks += 2;
    else if (state.retro_bottom === 'logo_nome') chunks += 3;

    var price = BASE_PRICE + chunks * 5.00;

    state.totalAddons = chunks;
    state.totalPrice = price;
    return { addons: chunks, price: price };
  }

  function formatPrice(n) {
    return '\u20AC' + n.toFixed(2).replace('.', ',');
  }

  function parseEuroSetting(val, fallback) {
    if (!val) return fallback;
    var n = parseFloat(String(val).replace(',', '.'));
    return isNaN(n) ? fallback : n;
  }

  /* ============================================================
     DROP GATE
     ============================================================ */
  var dropConfig = {
    enabled: false,
    dropTime: null,        // Date
    label: ''
  };

  function initDropConfig() {
    var enabled = root.getAttribute('data-purchase-enabled') === 'true';
    var dateStr = root.getAttribute('data-drop-date') || '';
    var timeStr = root.getAttribute('data-drop-time') || '';
    var label = root.getAttribute('data-drop-label') || 'Disponibile al drop';
    var dt = parseRomeDateTime(dateStr, timeStr);
    dropConfig = { enabled: enabled, dropTime: dt, label: label };

    state.shippingCost = parseEuroSetting(root.getAttribute('data-shipping-cost'), 5.90);
    state.shippingFreeThreshold = parseEuroSetting(root.getAttribute('data-shipping-threshold'), 50);
  }

  // Converte "AAAA-MM-GG" + "HH:MM" (ora locale Europe/Rome) in un Date UTC reale,
  // gestendo automaticamente CET (+01:00) e CEST (+02:00).
  function parseRomeDateTime(dateStr, timeStr) {
    if (!dateStr) return null;
    var dParts = dateStr.split('-');
    if (dParts.length !== 3) return null;
    var y = parseInt(dParts[0], 10);
    var mo = parseInt(dParts[1], 10);
    var d = parseInt(dParts[2], 10);
    var h = 0, mi = 0;
    if (timeStr) {
      var tParts = timeStr.split(':');
      h = parseInt(tParts[0], 10) || 0;
      mi = parseInt(tParts[1], 10) || 0;
    }
    if (isNaN(y) || isNaN(mo) || isNaN(d)) return null;

    // Stima iniziale: interpretiamo come UTC
    var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
    // Calcola offset Europe/Rome per quel momento
    var offsetMin = getTimezoneOffsetMinutes('Europe/Rome', guess);
    // L'utente ha scritto ora locale Roma -> real UTC = guess - offset
    var real = guess - offsetMin * 60000;
    // Ricompute con il vero UTC per DST boundary edge case
    var offsetMin2 = getTimezoneOffsetMinutes('Europe/Rome', real);
    if (offsetMin2 !== offsetMin) real = guess - offsetMin2 * 60000;
    return new Date(real);
  }

  // Offset in minuti (positivo a est di UTC) della timezone nel momento utcMs
  function getTimezoneOffsetMinutes(tz, utcMs) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
      var parts = fmt.formatToParts(new Date(utcMs));
      var obj = {};
      parts.forEach(function (p) { if (p.type !== 'literal') obj[p.type] = p.value; });
      var asUtc = Date.UTC(+obj.year, +obj.month - 1, +obj.day, +obj.hour % 24, +obj.minute, +obj.second);
      return Math.round((asUtc - utcMs) / 60000);
    } catch (e) {
      // Fallback: assume CEST (+120) tra fine marzo e fine ottobre, altrimenti CET (+60)
      var d = new Date(utcMs);
      var m = d.getUTCMonth() + 1;
      return (m >= 4 && m <= 9) ? 120 : 60;
    }
  }

  // Disponibile all'acquisto se: flag attivo E (nessun drop set OR adesso >= drop)
  function isPurchaseLive() {
    if (!dropConfig.enabled) return false;
    if (!dropConfig.dropTime) return true;
    return Date.now() >= dropConfig.dropTime.getTime();
  }

  // Pre-drop = acquisto non ancora live ma dropTime futuro valido
  function isPreDrop() {
    if (isPurchaseLive()) return false;
    if (dropConfig.dropTime && Date.now() < dropConfig.dropTime.getTime()) return true;
    return false;
  }

  /* ============================================================
     COUNTDOWN
     ============================================================ */
  var countdownTimer = null;

  function startCountdown() {
    stopCountdown();
    if (!dropConfig.dropTime) return;
    renderCountdown();
    countdownTimer = setInterval(function () {
      renderCountdown();
      if (isPurchaseLive()) {
        stopCountdown();
        updateAll(); // transizione a stato live
      }
    }, 1000);
  }

  function stopCountdown() {
    if (countdownTimer) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }
  }

  function renderCountdown() {
    if (!dropConfig.dropTime) return;
    var diff = Math.max(0, dropConfig.dropTime.getTime() - Date.now());
    var totalSec = Math.floor(diff / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;

    root.querySelectorAll('[data-role="countdown"], [data-role="countdown-inline"]').forEach(function (c) {
      var d = c.querySelector('[data-unit="days"]');
      var h = c.querySelector('[data-unit="hours"]');
      var m = c.querySelector('[data-unit="minutes"]');
      var s = c.querySelector('[data-unit="seconds"]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ============================================================
     DOM root
     ============================================================ */
  var root;

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    root = document.querySelector('.mtr-configurator');
    if (!root) return;

    initDropConfig();

    // Popola src delle thumbnail nelle card
    root.querySelectorAll('[data-img-key]').forEach(function (el) {
      var key = el.getAttribute('data-img-key');
      var url = img(key);
      if (url) el.src = url;
    });

    bindEvents();

    // Avvia countdown se pre-drop
    if (isPreDrop()) startCountdown();

    updateAll();
  }

  /* ============================================================
     EVENTI
     ============================================================ */
  function bindEvents() {
    root.addEventListener('change', function (e) {
      if (e.target.type === 'radio') onRadioChange(e);
    });

    var nomeField = root.querySelector('#mtr-nome-text');
    if (nomeField) {
      nomeField.addEventListener('input', function () {
        this.value = this.value.replace(/[^A-Za-z\u00C0-\u00FF\s]/g, '');
        state.testo_nome = this.value.trim().toUpperCase();
      });
    }

    var prevBtn = root.querySelector('.mtr-nav__prev');
    var nextBtn = root.querySelector('.mtr-nav__next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToStep(state.currentStep - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToStep(state.currentStep + 1); });

    root.querySelectorAll('.mtr-step-dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetStep = parseInt(this.getAttribute('data-step'));
        if (targetStep < state.currentStep) goToStep(targetStep);
      });
    });

    root.querySelectorAll('.mtr-preview__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        showPreviewZone(this.getAttribute('data-zone'));
      });
    });

    var arrowPrev = root.querySelector('.mtr-preview__arrow--prev');
    var arrowNext = root.querySelector('.mtr-preview__arrow--next');
    if (arrowPrev) arrowPrev.addEventListener('click', function () { cyclePreview(-1); });
    if (arrowNext) arrowNext.addEventListener('click', function () { cyclePreview(1); });

    var viewport = root.querySelector('.mtr-preview__viewport');
    if (viewport) {
      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(diff) > 40) cyclePreview(diff > 0 ? -1 : 1);
      }, { passive: true });
    }

    var buyBtn = root.querySelector('[data-role="buy-button"]');
    if (buyBtn) buyBtn.addEventListener('click', onBuyClick);
  }

  function onRadioChange(e) {
    var name = e.target.name;
    var value = e.target.value;

    if (state.hasOwnProperty(name)) state[name] = value;

    updateAll();

    // Focus anteprima sul lato rilevante
    if (name === 'fronte') showPreviewZone('fronte');
    else if (name === 'maniche') {
      showPreviewZone(value === 'nome_sx' ? 'sx' : 'dx');
    } else if (name === 'retro_top' || name === 'retro_bottom') {
      showPreviewZone('retro');
    } else if (name === 'colore') {
      // Ricarica tutte le thumbnail con la mappa colore corretta
      refreshOptionThumbnails();
    }
  }

  function refreshOptionThumbnails() {
    root.querySelectorAll('[data-img-key]').forEach(function (el) {
      var key = el.getAttribute('data-img-key');
      var url = img(key);
      if (url) el.src = url;
    });
  }

  /* ============================================================
     UPDATE COMPLETO
     ============================================================ */
  function updateAll() {
    calculatePrice();
    updatePreviewImages();
    updateSummaryImages();
    updateVisibility();
    updatePriceDisplay();
    updateShippingDisplay();
    updateNavButtons();
    updateStepIndicator();
    updateDropUI();
    updateSizeGuideHighlight();
    if (state.currentStep === 5) updateSummary();
  }

  function updateSizeGuideHighlight() {
    var table = root.querySelector('[data-role="size-guide-table"]');
    if (!table) return;
    table.querySelectorAll('[data-size]').forEach(function (el) {
      el.classList.toggle('mtr-size-guide__cell--active', el.getAttribute('data-size') === state.taglia);
    });
  }

  function getImageKeyForZone(zone) {
    switch (zone) {
      case 'fronte': return FRONTE_MAP[state.fronte] || 'mtr-FRONTE-LOGO';
      case 'dx':     return DX_MAP[state.maniche] || 'mtr-CLEAN-DX';
      case 'sx':     return SX_MAP[state.maniche] || 'mtr-CLEAN-SX';
      case 'retro':  return getRetroImgKey();
      default:       return '';
    }
  }

  function updatePreviewImages() {
    root.querySelectorAll('.mtr-preview__img').forEach(function (el) {
      var zone = el.getAttribute('data-zone');
      var url = img(getImageKeyForZone(zone));
      if (url) el.src = url;
    });
  }

  function updateSummaryImages() {
    root.querySelectorAll('.mtr-summary__img').forEach(function (el) {
      var zone = el.getAttribute('data-zone');
      var url = img(getImageKeyForZone(zone));
      if (url) el.src = url;
    });
  }

  function updateVisibility() {
    // Campo nome visibile se serve E non siamo allo step riepilogo
    var nomeInput = root.querySelector('.mtr-nome-input');
    if (nomeInput) {
      var show = needsNome() && state.currentStep !== MAX_STEP;
      nomeInput.style.display = show ? '' : 'none';
    }

    // retro_bottom visibile solo se retro_top != 'logo'
    // (se c'è già il logo in alto, nascondiamo le opzioni di logo in basso)
    var retroBottomSub = root.querySelector('[data-substep="retro_bottom"]');
    if (retroBottomSub) {
      var hideBottom = state.retro_top === 'logo';
      retroBottomSub.classList.toggle('mtr-substep--hidden', hideBottom);
      if (hideBottom && state.retro_bottom !== 'nessuno') {
        state.retro_bottom = 'nessuno';
        setRadio('retro_bottom', 'nessuno');
      }
    }
  }

  function setRadio(name, value) {
    var radio = root.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (radio) radio.checked = true;
  }

  function needsNome() {
    return state.fronte === 'logo_nome' ||
           state.maniche === 'nome_dx' ||
           state.maniche === 'nome_sx' ||
           state.maniche === 'nome_entrambe' ||
           state.retro_bottom === 'logo_nome';
  }

  /* ============================================================
     PREZZO — nascosto pre-drop
     ============================================================ */
  function updatePriceDisplay() {
    var priceText = formatPrice(state.totalPrice);
    root.querySelectorAll('.mtr-running-total, .mtr-total-price').forEach(function (el) {
      el.textContent = priceText;
    });

    var preDrop = isPreDrop();
    var navPrice = root.querySelector('[data-role="nav-price"]');
    var totalBlock = root.querySelector('[data-role="total-block"]');

    if (navPrice) navPrice.style.visibility = preDrop ? 'hidden' : '';
    if (totalBlock) totalBlock.style.display = preDrop ? 'none' : '';

    // Data-attribute globale per hiding prezzi nelle card opzioni (gestito via CSS)
    root.setAttribute('data-pre-drop', preDrop ? 'true' : 'false');
  }

  function updateShippingDisplay() {
    var el = root.querySelector('[data-role="ship-value"]');
    if (!el) return;
    if (state.totalPrice >= state.shippingFreeThreshold) {
      el.innerHTML = '<span class="mtr-ship-free">GRATIS</span>';
    } else {
      el.textContent = formatPrice(state.shippingCost);
    }
  }

  /* ============================================================
     DROP UI — countdown, pulsante disabilitato, banner
     ============================================================ */
  function updateDropUI() {
    var preDrop = isPreDrop();
    var live = isPurchaseLive();

    var cdTop = root.querySelector('[data-role="countdown"]');
    var cdInline = root.querySelector('[data-role="countdown-inline"]');
    if (cdTop) cdTop.style.display = preDrop ? '' : 'none';
    if (cdInline) cdInline.style.display = preDrop ? '' : 'none';

    var btn = root.querySelector('[data-role="buy-button"]');
    if (!btn) return;

    var textEl = btn.querySelector('.mtr-add-to-cart__text');
    if (preDrop || !dropConfig.enabled) {
      btn.disabled = true;
      btn.classList.add('mtr-add-to-cart--locked');
      if (textEl) textEl.textContent = dropConfig.label || 'Acquisto non ancora disponibile';
    } else if (live) {
      btn.disabled = false;
      btn.classList.remove('mtr-add-to-cart--locked');
      if (textEl) textEl.textContent = 'ACQUISTA ORA';
    }
  }

  /* ============================================================
     STEP INDICATOR
     ============================================================ */
  function updateStepIndicator() {
    root.querySelectorAll('.mtr-step-dot').forEach(function (dot) {
      var n = parseInt(dot.getAttribute('data-step'));
      dot.classList.remove('active', 'completed');
      if (n === state.currentStep) dot.classList.add('active');
      else if (n < state.currentStep) dot.classList.add('completed');
    });

    root.querySelectorAll('.mtr-step-item').forEach(function (item) {
      var n = parseInt(item.getAttribute('data-step'));
      item.classList.remove('active', 'completed');
      if (n === state.currentStep) item.classList.add('active');
      else if (n < state.currentStep) item.classList.add('completed');
    });

    root.querySelectorAll('.mtr-step-line').forEach(function (line) {
      var after = parseInt(line.getAttribute('data-after-step'));
      line.classList.toggle('completed', after < state.currentStep);
    });
  }

  /* ============================================================
     NAV STEP
     ============================================================ */
  var MAX_STEP = 4;

  function goToStep(n) {
    if (n < 1 || n > MAX_STEP) return;

    // Validazione nome prima dello step finale
    if (n === MAX_STEP && needsNome() && !state.testo_nome) {
      var nomeField = root.querySelector('#mtr-nome-text');
      if (nomeField) {
        nomeField.focus();
        nomeField.classList.add('mtr-nome-input__field--error');
        setTimeout(function () { nomeField.classList.remove('mtr-nome-input__field--error'); }, 1500);
      }
      return;
    }

    state.currentStep = n;

    root.querySelectorAll('.mtr-step').forEach(function (el) {
      el.classList.toggle('active', parseInt(el.getAttribute('data-step')) === n);
    });

    updateAll();

    if (n === 1) showPreviewZone('fronte');
    else if (n === 2) showPreviewZone('dx');
    else if (n === 3) showPreviewZone('retro');
    else if (n === 4) showPreviewZone('fronte');

    scrollToConfigurator();
  }

  function scrollToConfigurator() {
    var headerHeight = getHeaderHeight();
    var rect = root.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - headerHeight - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function getHeaderHeight() {
    var selectors = ['header', '.header', '.site-header', '#shopify-section-header', '[data-section-type="header"]'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var style = window.getComputedStyle(el);
        if (style.position === 'fixed' || style.position === 'sticky') {
          return el.offsetHeight;
        }
      }
    }
    return 80;
  }

  function updateNavButtons() {
    var prevBtn = root.querySelector('.mtr-nav__prev');
    var nextBtn = root.querySelector('.mtr-nav__next');
    var navBar = root.querySelector('.mtr-nav');

    if (prevBtn) prevBtn.style.display = state.currentStep > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = state.currentStep < MAX_STEP ? '' : 'none';
    if (navBar) navBar.style.display = state.currentStep === MAX_STEP ? 'none' : '';
  }

  /* ============================================================
     CAROUSEL ANTEPRIMA
     ============================================================ */
  var zones = ['fronte', 'dx', 'sx', 'retro'];
  var currentZoneIdx = 0;

  function showPreviewZone(zone) {
    currentZoneIdx = zones.indexOf(zone);
    if (currentZoneIdx === -1) currentZoneIdx = 0;

    root.querySelectorAll('.mtr-preview__img').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-zone') === zone);
    });
    root.querySelectorAll('.mtr-preview__dot').forEach(function (dot) {
      dot.classList.toggle('active', dot.getAttribute('data-zone') === zone);
    });
  }

  function cyclePreview(dir) {
    currentZoneIdx = (currentZoneIdx + dir + zones.length) % zones.length;
    showPreviewZone(zones[currentZoneIdx]);
  }

  /* ============================================================
     RIEPILOGO
     ============================================================ */
  function updateSummary() {
    var list = root.querySelector('.mtr-summary__list');
    var breakdown = root.querySelector('.mtr-summary__breakdown');
    if (!list || !breakdown) return;

    var items = [];
    var priceLines = [['T-shirt base (' + coloreLabel() + ')', BASE_PRICE]];

    // Colore
    items.push('<strong>Colore:</strong> ' + coloreLabel());

    // Fronte
    if (state.fronte === 'logo_nome') {
      items.push('<strong>Fronte:</strong> Logo cuore + Nome');
      priceLines.push(['Nome fronte', ADDON_NAME]);
    } else {
      items.push('<strong>Fronte:</strong> Logo cuore');
    }

    // Maniche
    if (state.maniche === 'nome_dx') {
      items.push('<strong>Manica destra:</strong> Nome');
      priceLines.push(['Nome manica DX', ADDON_NAME]);
    } else if (state.maniche === 'nome_sx') {
      items.push('<strong>Manica sinistra:</strong> Nome');
      priceLines.push(['Nome manica SX', ADDON_NAME]);
    } else if (state.maniche === 'nome_entrambe') {
      items.push('<strong>Maniche:</strong> Nome su entrambe');
      priceLines.push(['Nome manica DX', ADDON_NAME]);
      priceLines.push(['Nome manica SX', ADDON_NAME]);
    } else {
      items.push('<strong>Maniche:</strong> Nessuna personalizzazione');
    }

    // Retro alto
    var topLabel = { logo: 'Logo', font1: 'Scritta (Corsivo)', font2: 'Scritta (Bold)' }[state.retro_top];
    items.push('<strong>Retro (alto):</strong> ' + topLabel);

    // Retro basso
    if (state.retro_bottom === 'logo') {
      items.push('<strong>Retro (basso):</strong> Logo');
      priceLines.push(['Logo basso retro', ADDON_LOGO_BASSO]);
    } else if (state.retro_bottom === 'logo_nome') {
      items.push('<strong>Retro (basso):</strong> Logo + Nome');
      priceLines.push(['Logo basso retro', ADDON_LOGO_BASSO]);
      priceLines.push(['Nome basso retro', ADDON_NOME_BASSO]);
    }

    // Nome personalizzato
    if (needsNome() && state.testo_nome) {
      items.push('<strong>Nome personalizzato:</strong> ' + escapeHtml(state.testo_nome));
    }

    list.innerHTML = items.map(function (i) { return '<li>' + i + '</li>'; }).join('');

    var preDrop = isPreDrop();
    if (preDrop) {
      breakdown.innerHTML = '';
      breakdown.style.display = 'none';
    } else {
      breakdown.style.display = '';
      var linesHtml = priceLines.map(function (l) {
        return '<span class="mtr-summary__breakdown-line">' +
               '<span>' + l[0] + '</span>' +
               '<span>' + formatPrice(l[1]) + '</span>' +
               '</span>';
      }).join('');
      var shipHtml = '<span class="mtr-summary__breakdown-line mtr-summary__breakdown-line--ship">' +
                     '<span>Spedizione</span>' +
                     '<span>' + (state.totalPrice >= state.shippingFreeThreshold
                        ? '<span class="mtr-ship-free">GRATIS</span>'
                        : formatPrice(state.shippingCost)) + '</span>' +
                     '</span>';
      var total = state.totalPrice + (state.totalPrice >= state.shippingFreeThreshold ? 0 : state.shippingCost);
      breakdown.innerHTML = '<p class="mtr-summary__breakdown-title">Dettaglio prezzo</p>' +
        linesHtml + shipHtml +
        '<span class="mtr-summary__breakdown-total"><strong>Totale: ' + formatPrice(total) + '</strong></span>';
    }
  }

  function coloreLabel() {
    return state.colore === 'grigio' ? 'Grigio Scuro' : 'Nero';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ============================================================
     TESTI leggibili per carrello / ordine
     ============================================================ */
  function getCustomerFronte() {
    if (state.fronte === 'logo_nome') return 'Logo cuore + Nome';
    return 'Logo cuore';
  }

  function getCustomerManiche() {
    if (state.maniche === 'nome_dx') return 'Nome su manica destra';
    if (state.maniche === 'nome_sx') return 'Nome su manica sinistra';
    if (state.maniche === 'nome_entrambe') return 'Nome su entrambe le maniche';
    return 'Nessuna';
  }

  function getCustomerRetro() {
    var parts = [];
    var topLabel = { logo: 'Logo in alto', font1: 'Scritta Corsivo', font2: 'Scritta Bold' }[state.retro_top];
    parts.push(topLabel);
    if (state.retro_bottom === 'logo') parts.push('Logo in basso');
    if (state.retro_bottom === 'logo_nome') parts.push('Logo + Nome in basso');
    return parts.join(' + ');
  }

  function getStaffFronte() {
    if (state.fronte === 'logo_nome') return 'LOGO cuore petto sx + NOME petto';
    return 'LOGO cuore petto sx';
  }

  function getStaffManiche() {
    if (state.maniche === 'nome_dx') return 'NOME manica DX';
    if (state.maniche === 'nome_sx') return 'NOME manica SX';
    if (state.maniche === 'nome_entrambe') return 'NOME manica DX + SX';
    return 'Vuoto';
  }

  function getStaffRetro() {
    var parts = [];
    var topMap = { logo: 'LOGO-ALTO', font1: 'PAYOFF-F1-Corsivo', font2: 'PAYOFF-F2-Bold' };
    parts.push(topMap[state.retro_top]);
    if (state.retro_bottom === 'logo') parts.push('LOGO-BASSO');
    if (state.retro_bottom === 'logo_nome') parts.push('LOGO-BASSO + NOME-BASSO');
    return parts.join(' / ');
  }

  /* ============================================================
     TROVA VARIANTE — option-order agnostic
     ============================================================ */
  // Identifica quale slot (option1/2/3) ospita Taglia, Colore, Addon
  // leggendo product.option_names. Fallback heuristico sui valori.
  function resolveOptionSlots() {
    var names = (window.MTR_PRODUCT && window.MTR_PRODUCT.option_names) || [];
    var slots = { size: -1, color: -1, addon: -1 };
    names.forEach(function (n, i) {
      var nm = String(n || '').toLowerCase().trim();
      if (/taglia|size/.test(nm)) slots.size = i;
      else if (/color/.test(nm)) slots.color = i;
      else if (/addon|opzion|person|^_?p$/.test(nm)) slots.addon = i;
    });
    return slots;
  }

  function variantMatches(variant, wanted, slots) {
    var opts = variant.options || [variant.option1, variant.option2, variant.option3];
    if (slots.size >= 0 && wanted.size != null && opts[slots.size] !== wanted.size) return false;
    if (slots.color >= 0 && wanted.color != null && opts[slots.color] !== wanted.color) return false;
    if (slots.addon >= 0 && wanted.addon != null && String(opts[slots.addon]) !== String(wanted.addon)) return false;
    return true;
  }

  function findVariant(size, color, addons) {
    if (!window.MTR_PRODUCT) return null;
    var variants = window.MTR_PRODUCT.variants;
    var slots = resolveOptionSlots();
    var colorLabel = color === 'grigio' ? 'Grigio Scuro' : 'Nero';

    // 1) match completo con tutti gli slot rilevanti
    var wanted = { size: size, color: colorLabel, addon: addons };
    for (var i = 0; i < variants.length; i++) {
      if (!variants[i].available) continue;
      if (variantMatches(variants[i], wanted, slots)) return variants[i];
    }
    // 2) senza addon (prodotto con sole varianti Taglia+Colore, prezzo unico)
    var w2 = { size: size, color: colorLabel };
    for (var j = 0; j < variants.length; j++) {
      if (!variants[j].available) continue;
      if (variantMatches(variants[j], w2, { size: slots.size, color: slots.color, addon: -1 })) return variants[j];
    }
    // 3) solo taglia (niente colore come variante, sarà property)
    var w3 = { size: size };
    for (var k = 0; k < variants.length; k++) {
      if (!variants[k].available) continue;
      if (variantMatches(variants[k], w3, { size: slots.size, color: -1, addon: -1 })) return variants[k];
    }
    // 4) prima variante disponibile (prodotto single-variant)
    for (var m = 0; m < variants.length; m++) {
      if (variants[m].available) return variants[m];
    }
    return null;
  }

  /* ============================================================
     BUY CLICK -> ADD TO CART -> CHECKOUT
     ============================================================ */
  function onBuyClick() {
    if (!isPurchaseLive()) return; // gate

    if (needsNome() && !state.testo_nome) {
      alert('Inserisci il tuo nome personalizzato prima di procedere.');
      return;
    }

    var result = calculatePrice();
    var variant = findVariant(state.taglia, state.colore, result.addons);

    if (!variant) {
      alert('Combinazione non disponibile. Prova una taglia diversa.');
      return;
    }

    var properties = {};

    properties['Colore'] = coloreLabel();
    properties['Fronte'] = getCustomerFronte();
    properties['Maniche'] = getCustomerManiche();
    properties['Retro'] = getCustomerRetro();
    if (state.testo_nome) properties['Nome personalizzato'] = state.testo_nome;

    properties['_Colore'] = state.colore.toUpperCase();
    properties['_Stampa Fronte'] = getStaffFronte();
    properties['_Stampa Maniche'] = getStaffManiche();
    properties['_Stampa Retro'] = getStaffRetro();
    if (state.testo_nome) properties['_Testo da stampare'] = state.testo_nome;
    properties['_Num addons'] = String(result.addons);

    var imgFronte = img(getImageKeyForZone('fronte'));
    var imgDx = img(getImageKeyForZone('dx'));
    var imgSx = img(getImageKeyForZone('sx'));
    var imgRetro = img(getImageKeyForZone('retro'));
    if (imgFronte) properties['_Img Fronte'] = 'https:' + imgFronte;
    if (imgDx)     properties['_Img Destra'] = 'https:' + imgDx;
    if (imgSx)     properties['_Img Sinistra'] = 'https:' + imgSx;
    if (imgRetro)  properties['_Img Retro'] = 'https:' + imgRetro;

    var btn = root.querySelector('[data-role="buy-button"]');
    var textEl = btn.querySelector('.mtr-add-to-cart__text');
    var loadEl = btn.querySelector('.mtr-add-to-cart__loading');
    if (textEl) textEl.style.display = 'none';
    if (loadEl) loadEl.style.display = '';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variant.id,
        quantity: 1,
        properties: properties
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Errore aggiunta al carrello');
      return res.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      alert('Errore: ' + err.message);
      if (textEl) textEl.style.display = '';
      if (loadEl) loadEl.style.display = 'none';
      btn.disabled = false;
    });
  }

  /* ============================================================
     AVVIO
     ============================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
